import React from "react";
import styled from "styled-components";
import { push } from "connected-react-router";
import { connect } from "react-redux";

import appUrls from "../../config/appUrls";

import CloseIcon from "../../components/icons/Close";
import DropdownIcon from "../../components/icons/Dropdown";
import RadioButton from "../../components/RadioButton";
import HomeSearchIcon from "../../components/icons/HomeSearch";
import ChannelsDropdownIcon from "../../components/icons/ChannelsDropdown";
import CircleGraph from "../../components/graphs/CircleFillGraph";
import PercentileGraph from "../../components/graphs/PercentileBubbleGraph";
import Textfield from "../../components/TextField";
import {
  SwitchButtonsWrap,
  SwitchButton,
  DropDownButton,
  DropdownGraphContainer,
  DropdownGraphChild,
  MapExplainText
} from "../../components/StyledComponents";

var data = [
  {
    id: 0,
    value: 63,
    name: "زمن التقديم"
  },
  {
    id: 1,
    value: 28,
    name: "زمن الانتظار"
  },
  {
    id: 2,
    value: 84,
    name: "تكلفة"
  },
  {
    id: 3,
    value: 24,
    name: "الانتاجية"
  },
  {
    id: 4,
    value: 11,
    name: "مستوى الثقة "
  },
  {
    id: 5,
    value: 83,
    name: "مستوى رضا المتعاملين"
  },
  {
    id: 6,
    value: 67,
    name: "زمن الخدمة القياسي"
  },
  {
    id: 7,
    value: 95,
    name: "استمرارية الخدمة"
  },
  {
    id: 8,
    value: 18,
    name: "نسبة الإشغال"
  }
];

const RightContainer = styled.div`
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
  position: fixed;
  overflow-y: auto;
  overflow-x: hidden;
  width: 23%;
  background-color: ${props => props.theme.backgroundSecondary};
  transition: background-color ease 1s;
  display: flex;
  flex-direction: column;
  text-align: right;

  @media (max-width: 575px) {
    background-color: ${props => props.theme.background};
    width: 100%;
    height: 87.5vh;
    top: 0;
  }
`;

const Option = styled.div`
  display: flex;

  flex-direction: row-reverse;
  align-items: ${props => (props.open ? "flex-start" : "center")};
  border-top: 1px solid #416183;
  padding-right: 10%;
  padding-top: ${props => (props.open ? "8%" : "8%")};
  padding-bottom: ${props => (props.open ? "8%" : "8%")};
  cursor: pointer;
  @media (min-width: 1800px) {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  @media (max-width: 575px) {
    /* height: ${props => (props.open ? "5%" : "9.5%")};
    padding-top: ${props => (props.open ? "4%" : 0)}; */

    height: 2.5%;
    padding: 12px 10% 12px 0
  }
`;

const OptionDetail = styled.div`
  height: ${props => (props.open ? "100%" : 0)};
  overflow: hidden;
  transition: height 0.2s ease-out;
`;

const TitleAction = styled.div`
  height: 19%;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  @media (min-width: 1800px) {
    padding: 22px 0;
  }

  @media (max-width: 575px) {
    background-color: ${props => props.theme.backgroundSecondary};
  }
`;
const TitleContainer = styled.div`
  margin-right: 10%;
  font-size: 15px;
  color: ${props =>
    props.open ? props.theme.textHighlight : props.theme.text};
  display: flex;
  flex-direction: column;
  @media (min-width: 1800px) {
    font-size: 30px;
    line-height: 51px;
  }

  @media (max-width: 575px) {
    margin-right: 5%;
  }
`;

const TextContainer = styled.div`
  margin-right: 10%;
  font-size: 15px;
  color: ${props =>
    props.open ? props.theme.textHighlight : props.theme.text};
  display: flex;
  flex-direction: column;
  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 36px;
  }
  @media (max-width: 575px) {
    margin-right: 5%;
  }
`;

const Title = styled.span`
  font-family: "dubai-bold";
  font-size: 15px;
  @media (min-width: 1800px) {
    font-size: 30px;
    line-height: 51px;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10% 0 25%;
`;

const DropdownGraphContainerBg = styled(DropdownGraphContainer)`
  background-color: ${props => props.theme.background};
  @media (min-width: 1800px) {
    height: 30vh;
  }
`;

const CloseIconWithMargin = styled(CloseIcon)`
  margin-right: 10%;
`;

const DropdownCircleAndDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DropdownCircleGraphContainer = styled.div`
  height: 42.38px;
  width: 42.38px;

  @media (min-width: 1800px) {
    height: 55px;
    width: 55px;
  }
  @media (max-width: 575px) {
    height: 50px;
    width: 50px;
  }
`;

const SingleCircleDetailDropDown = styled.div`
  font-size: 9px;
  text-align: center;
  line-height: 14px;
  margin: 5px 0 20px 0;
  color: ${props => props.theme.text};
`;

const GraphOptions = ({
  chosen,
  setChosen,
  push,
  setChosenGraph,
  chosenGraph,
  channelsDropdownOpen,
  setchannelsDropdownOpen,
  mapOption,
  setMapOption,
  verticalGraphData
}) => {
  return (
    <RightContainer>
      <TitleAction>
        <CloseIconWithMargin onClick={() => push(appUrls.HOME)} />
        <TitleContainer open>
          <span>جهة حكومية</span>
          <Title>340,000 معاملة</Title>
        </TitleContainer>
      </TitleAction>
      <Option open={chosen === 1} onClick={() => setChosen(1)}>
        <DropdownIcon open={chosen === 1} />
        <TextContainer open={chosen === 1}>تقييم الجهة الحكومية</TextContainer>
      </Option>
      <OptionDetail open={chosen === 1}>
        <PercentileGraph />
      </OptionDetail>

      <Option open={chosen === 2} onClick={() => setChosen(2)}>
        <DropdownIcon open={chosen === 2} />
        <TextContainer open={chosen === 2}>تقييم الخدمات</TextContainer>
      </Option>
      <OptionDetail open={chosen === 2}>
        <ActionsContainer>
          <SwitchButtonsWrap>
            <SwitchButton
              onClick={() => setChosenGraph("public")}
              outlined={chosenGraph !== "public"}
            >
              عامة
            </SwitchButton>
            <SwitchButton
              onClick={() => setChosenGraph("main")}
              outlined={chosenGraph !== "main"}
            >
              رئيسية
            </SwitchButton>
          </SwitchButtonsWrap>
          <Textfield
            placeholder="بحث بإسم الخدمة"
            rounded
            icon={<HomeSearchIcon />}
          />

          <DropDownButton
            onClick={() => setchannelsDropdownOpen(!channelsDropdownOpen)}
            outlined={!channelsDropdownOpen}
            open={channelsDropdownOpen}
            size="small"
          >
            <ChannelsDropdownIcon selected={channelsDropdownOpen === true} />
            <span> تقييم بإسم القنوات</span>
          </DropDownButton>
          {channelsDropdownOpen ? (
            <DropdownGraphContainerBg background>
              {data.map(item => (
                <DropdownGraphChild
                  // onClick={() => this.handleGraphDropdown(item.id)}
                  selected
                  key={`dropdown-item-${item.id}`}
                >
                  <DropdownCircleAndDetail>
                    <DropdownCircleGraphContainer>
                      <CircleGraph value={item.value} title={item.name} />
                    </DropdownCircleGraphContainer>
                    <SingleCircleDetailDropDown>
                      {item.name}
                    </SingleCircleDetailDropDown>
                  </DropdownCircleAndDetail>
                </DropdownGraphChild>
              ))}
            </DropdownGraphContainerBg>
          ) : (
            <>
              <RadioButton
                name="servicesByCategory"
                label="خدمات حسب فئات المتعاملين"
                options={[
                  { id: 1, label: "الخدمات الحكومية للافراد" },
                  { id: 2, label: "الخدمات الحكومية للشركات" },
                  { id: 3, label: "الخدمات الحكومية لجهة حكومية أخرى" }
                ]}
              />
              <RadioButton
                name="servicesByNature"
                label="خدمات حسب طبيعة تقديمها"
                options={[
                  { id: 1, label: "خدمات تأتي بطلب تصريح" },
                  { id: 2, label: "خدمات النفع العام" }
                ]}
              />
            </>
          )}
        </ActionsContainer>
      </OptionDetail>

      <Option open={chosen === 3} onClick={() => setChosen(3)}>
        <DropdownIcon open={chosen === 3} />
        <TextContainer open={chosen === 3}>مراكز الخدمة</TextContainer>
      </Option>
      <OptionDetail open={chosen === 3}>
        <ActionsContainer>
          <MapExplainText>
            هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي
            القارئ عن التركيز على الشكل الخارجي للنص أو شكل توضع{" "}
          </MapExplainText>
          <SwitchButtonsWrap>
            <SwitchButton
              onClick={() => setMapOption("MAP")}
              outlined={mapOption !== "MAP"}
            >
              مواقع
            </SwitchButton>
            <SwitchButton
              onClick={() => setMapOption("VIZ")}
              outlined={mapOption !== "VIZ"}
            >
              مؤشرات
            </SwitchButton>
          </SwitchButtonsWrap>
          <Textfield
            placeholder="بحث بإسم مركز الخدمة"
            rounded
            icon={<HomeSearchIcon />}
          />
        </ActionsContainer>
      </OptionDetail>
    </RightContainer>
  );
};

export default connect(
  null,
  { push }
)(GraphOptions);
